const RECAPTCHA_LANGUAGE_MAP = {
  pl: "pl",
  es: "es",
};

export const getRecaptchaLanguage = (language) => {
  if (!language) {
    return "pl";
  }

  const normalizedLanguage = language.toLowerCase().split("-")[0];

  return RECAPTCHA_LANGUAGE_MAP[normalizedLanguage] || "pl";
};
